import React from "react";
// eslint-disable-next-line
import NavList from "../NavList/NavList";
import classes from "./NavBar.module.css";
import SideDrawerToggle from "../SideDrawerToggle/SideDrawerToggle";
import Logo from "../Logo/Logo";

type NavBarProps = {
    sideDrawerToggleClick: () => void;
};

const NavBar: React.FC<NavBarProps> = (props) => {
    return (
        <header className={classes.NavBar}>
            <div className={[/*classes.MobileOnly*/ ""].join(" ")}>
                <SideDrawerToggle click={props.sideDrawerToggleClick} />
            </div>
            <Logo />
            {/* <nav className={classes.DesktopOnly}>
        <NavList />
      </nav> */}
        </header>
    );
};

export default NavBar;
